import { render } from "./FormManageView.vue?vue&type=template&id=01447e25&scoped=true"
import script from "./FormManageView.vue?vue&type=script&lang=js"
export * from "./FormManageView.vue?vue&type=script&lang=js"

import "./FormManageView.vue?vue&type=style&index=0&id=01447e25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01447e25"]])

export default __exports__